export default "__VITE_ASSET__CdLG4eug__"